// extracted by mini-css-extract-plugin
export var centerText = "_cw-8";
export var container = "_cw-0";
export var doughnutContainer = "_cw-7";
export var legend = "_cw-a";
export var legendItemColorDisplay = "_cw-b";
export var legendItemLabel = "_cw-d";
export var legendItemValue = "_cw-c";
export var lg = "_cw-5";
export var maxWidth = "_cw-9";
export var md = "_cw-4";
export var responsive = "_cw-6";
export var sm = "_cw-3";
export var xs = "_cw-2";
export var xxs = "_cw-1";